// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QJEV","label":"styles_label__1-Ug6"};